import { Heading, Text,  Flex,  Tabs, Tab, TabPanels, TabPanel, TabList} from "@chakra-ui/react";
import { useParams } from 'react-router-dom';
import useFetch from "../../hooks/useFetchAK";
import SkeletonPage from "../../components/SkeletonPage/SkeletonPage";
import SubjectLoad from "../../components/ak/SubjectLoad";

export default function CourceDetails() {

  var { index } = useParams();
  var { loading, error, data } = useFetch("get/allsubjectfrmlivecourseclass?courseid=" + index);



  return (
    <>
      <Flex as="home" width="100%" align="center" px={10} wrap={'wrap'} direction={'column'} paddingBottom={2}>

        <Heading
          fontWeight={'bold'}
          fontSize={'3xl'}
          lineHeight={'110%'}>
         Cource{' '}
          <Text as={'span'} color={'orange.400'}>
            Subjects..
          </Text>
        </Heading>


        {loading && <SkeletonPage />}


        {error && <center style={{ padding: 10 }}><h5>Oops, an error occurred.</h5></center>}


        {/* 
        <Flex direction='row' wrap={'wrap'} alignItems={'center'}>

          {data && !error &&
            data?.subjects?.map((s, i) => (
              <Button
                mt={8}
                marginLeft={8}
                rounded={'md'}
                _activeLink={
                  {
                    color: 'white',
                    backgroundColor: 'blue'
                  }
                }
              >
                {s.subject}
              </Button>
            ))

          }
        </Flex> */}


        <br />

        <Tabs variant='soft-rounded' colorScheme={'green'} >
          <TabList flexWrap={'wrap'} >
            {data && !error &&
              data["data"].map((s, i) => (
                <Tab key={i + 1}
                >
                  {s.subject_name}
                </Tab>
              ))
            }
          </TabList>

          <TabPanels>
            {data && !error &&
              data["data"].map((s, i) => (
                <TabPanel key={i + 1}
                >
                  <SubjectLoad subject={s.subjectid} batch={index} />
                  
                  </TabPanel>
              ))
            }
          </TabPanels>

        </Tabs>



      </Flex>
    </>

  )
}
